import React, {
  CSSProperties,
  FC,
} from 'react';
import {
  Button, Row,
} from './Styles';
import SquadSemiBoldText from '../../../../components/Text/SquadSemiBoldText';

const ReopenButton: FC<Props> = ({
  isEnglish,
  timeWait,
  onClick,
  style,
}) => {
  // 有返回箭头时
  return (
    <Button
      onClick={() => onClick()}
      style={{ width: '140px', height: '47px', background: '#11202B', borderRadius: '23px', ...style }}
    >
      <Row>
        {
          isEnglish ? (
            <SquadSemiBoldText fontSize={16} color={'#FFFFFF'}>
              Reopen
            </SquadSemiBoldText>
          ) : (
            <div style={{ fontSize: '14px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '20px' }}>
              重新开柜
            </div>
          )
        }
        {
          timeWait != null && (
            <Row style={{ fontSize: '14px', fontFamily: 'Squad-Regular, Squad', color: '#FFFFFF', justifyContent: 'center', alignItems: 'center' }}>
              (<div style={{ marginTop: '2px' }}>{timeWait}</div>s)
            </Row>
          )
        }
      </Row>
    </Button>
  );
};

export interface Props {
  onClick: () => void;
  isEnglish: boolean;
  timeWait?: string;
  style?: CSSProperties;
}

export default ReopenButton;
